module.exports = __webpack_public_path__ + "img/pants_length.99e967b6.png";